function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { DEFAULT_TIMEOUT } from '../config/constants';
export var useTimeout = function useTimeout(_ref) {
  var _ref$tips = _ref.tips,
    tips = _ref$tips === void 0 ? '' : _ref$tips,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? DEFAULT_TIMEOUT : _ref$delay,
    timeoutFn = _ref.timeoutFn;
  var timer = setTimeout(function () {
    timeoutFn(new Error("".concat(tips, "[timeout:").concat(delay, "ms]")));
  }, delay);
  return timer;
};

/** 加载脚本 */
export var loadScript = function loadScript(src, scriptParams) {
  return new Promise(function (resolve) {
    var scriptEle = document.createElement('script');
    scriptEle.src = src;
    if (scriptParams) {
      Object.entries(scriptParams).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        scriptEle[key] = value;
      });
    }
    var handler = function handler() {
      scriptEle.removeEventListener('load', handler);
      resolve();
    };
    scriptEle.addEventListener('load', handler);
    if (document.head) {
      document.head.appendChild(scriptEle);
    }
  });
};
export var loadScriptWithTimeout = function loadScriptWithTimeout(_ref4) {
  var src = _ref4.src,
    scriptParams = _ref4.scriptParams,
    delay = _ref4.delay;
  return new Promise(function (resolve, reject) {
    var timer = useTimeout({
      tips: '加载渠道sdk超时',
      delay: delay,
      timeoutFn: reject
    });
    loadScript(src, scriptParams).then(function () {
      clearTimeout(timer);
      resolve();
    });
  });
};

// TODO:后续改成sentry之类的
export var useLog = function useLog(loggerPrefix) {
  return function (_ref5) {
    var level = _ref5.level,
      msg = _ref5.msg,
      extra = _ref5.extra;
    var logInfo = "[".concat(loggerPrefix, "]").concat(msg);
    if (extra) {
      if (level === 'error') {
        logInfo += "[msg\uFF1A".concat(extra.msg || extra.message, "]");
      } else {
        logInfo += "[".concat(JSON.stringify(extra), "]");
      }
    }
    // eslint-disable-next-line no-console
    console[level](logInfo);
  };
};

/** 获取随机值,默认8位 */
export var getRandomId = function getRandomId() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  return Math.random().toString(32).slice(-length);
};